import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Statistics } from 'src/interfaces/AccountState';

import './StatementSummary.scss';
import { formatAmountToFixed } from 'src/utils/utils';

interface StatementSummaryProps {
  statistics: Statistics,
  divisor: number
}

function StatementSummary({ statistics, divisor }: StatementSummaryProps) {
  const { t } = useTranslation();

  return (
    <div className="statement-summary__totals-container">
      <h2 className="statement-summary__title">{ t('accountHistory.summaryDesc') }</h2>
      <span className="statement-summary__totals-title">{ t('accountHistory.totalsZar') }</span>
      <div className="statement-summary__totals-divider-header" />
      <div className="statement-summary__totals-item">
        <span className="statement-summary__totals-label">{ t('accountHistory.openingBalance') }</span>
        <span className="statement-summary__totals-label-results">{
          formatAmountToFixed(statistics ? statistics.openingBalance : 0, divisor, true)
        }
        </span>
      </div>
      <div className="statement-summary__totals-item">
        <span className="statement-summary__totals-label">{ t('accountHistory.debits') }</span>
        <span className="statement-summary__totals-label-results">{
          formatAmountToFixed(statistics ? statistics.totalDebits : 0, divisor, true)
        }</span>
      </div>
      <div className="statement-summary__totals-item">
        <span className="statement-summary__totals-label">{ t('accountHistory.credits') }</span>
        <span className="statement-summary__totals-label-results">{
          formatAmountToFixed(statistics ? statistics.totalCredits : 0, divisor, true)
        }</span>
      </div>
      <div className="statement-summary__totals-item">
        <span className="statement-summary__totals-label">{ t('accountHistory.closingBalance') }</span>
        <span className="statement-summary__totals-label-results">{
          formatAmountToFixed(statistics ? statistics.closingBalance : 0, divisor, true)
        }</span>
      </div>
      <div className="statement-summary__totals-final">
        <div className="statement-summary__totals-divider" />
        <span className="statement-summary__totals-title">{ t('accountHistory.transactionAnalysis') }</span>
        <div className="statement-summary__totals-divider" />
      </div>
      {
        _.map(statistics?.transactionsTypes, (transaction) => {
          return (
            <div className="statement-summary__totals-item" key={ transaction.id }>
              <span className="statement-summary__totals-label">{ transaction.name }</span>
              <span className="statement-summary__totals-label-results">
                { formatAmountToFixed(transaction.totalAmount, divisor, true) }
              </span>
            </div>
          );
        })
      }
    </div>
  );
}

export default StatementSummary;
